import { createTheme } from '@mui/material/styles';
import { tokens } from './tokens';

const theme = createTheme({
  palette: {
    primary: {
      main: tokens.colors.brand[500],
      dark: tokens.colors.brand[600],
      light: tokens.colors.brand[500],
    },
    secondary: {
      main: tokens.colors.brand[600],
    },
    success: { main: tokens.colors.success },
    warning: { main: tokens.colors.warning },
    error: { main: tokens.colors.danger },
    info: { main: tokens.colors.info },
    background: {
      default: tokens.colors.surface[0],
      paper: tokens.colors.surface[1],
    },
    text: {
      primary: tokens.colors.text[1],
      secondary: tokens.colors.text[2],
      disabled: tokens.colors.text.muted,
    },
    divider: tokens.colors.border,
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontSize: 18, fontWeight: 600 },
    h5: { fontSize: 16, fontWeight: 600 },
    h6: { fontSize: 15, fontWeight: 600 },
    body1: { fontSize: 14 },
    body2: { fontSize: 13 },
    caption: { fontSize: 12 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: tokens.radius.button,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 40,
          paddingLeft: 14,
          paddingRight: 14,
          borderRadius: tokens.radius.button,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
          '&:focus-visible': {
            boxShadow: `0 0 0 2px ${tokens.colors.surface[1]}, 0 0 0 4px ${tokens.colors.brand[500]}40`,
          },
        },
        containedPrimary: {
          backgroundColor: tokens.colors.brand[500],
          '&:hover': { backgroundColor: tokens.colors.brand[600] },
          '&:active': { backgroundColor: tokens.colors.brand[700] },
        },
        sizeSmall: { minHeight: 36, paddingLeft: 12, paddingRight: 12 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.card,
          border: `1px solid ${tokens.colors.border}`,
          boxShadow: tokens.elevation.shadowSm,
          padding: tokens.spacing[5],
          backgroundColor: tokens.colors.surface[1],
          '&:hover': {
            boxShadow: tokens.elevation.shadowMd,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.pill,
          fontWeight: 500,
          height: 24,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          width: 40,
          height: 40,
          '&:focus-visible': {
            boxShadow: `0 0 0 2px ${tokens.colors.brand[500]}40`,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.input,
          backgroundColor: tokens.colors.surface[1],
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.colors.border,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.colors.borderHover,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.colors.brand[500],
            borderWidth: 2,
          },
        },
        input: {
          backgroundColor: `${tokens.colors.surface[1]} !important`,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.colors.surface[1],
          '&:hover': { backgroundColor: tokens.colors.surface[1] },
          '&.Mui-focused': { backgroundColor: tokens.colors.surface[1] },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.MuiOutlinedInput-root': { backgroundColor: tokens.colors.surface[1] },
          '&.MuiFilledInput-root': { backgroundColor: tokens.colors.surface[1] },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.card,
          border: `1px solid ${tokens.colors.border}`,
          boxShadow: tokens.elevation.shadowSm,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
export { tokens };
